module.exports = __webpack_public_path__ + "img/dia_warn_cion.b0d7918f.png";